<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="GongYingShangList" data-title="常用明细项">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="规格" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.name" :value2="row.number" />
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="联系人" label2="地址" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.address" :key="row.address">
              <template #top>
                <div class="flex items-center gap-x-3">
                  <text>{{ row.contact_name }}</text>
                  <c_sex :value="row.contact_title == '先生' ? '男' : '女'" />
                  <text>{{ $phoneFormat(row.contact_phone) }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="type_name" />
        <el-table-column label="单位" prop="unit_name" />
        <el-table-column
          label="采购价"
          prop="price"
          :formatter="$tab_MoneyFormat"
          align="center"
        />
        <el-table-column label="备注" prop="remark" />
        <el-table-column label="操作" fixed="right" align="center" :width="120">
          <template #default="{ row }">
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  supplier_costitem_page,
  supplier_costitem_delete,
} from "@/http/supplier";
import { onDeleteConfirm } from "@/utils/funcs";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    supplier_id: Number,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.supplier_id = props.supplier_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      supplier_costitem_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(supplier_costitem_delete, row.id, onLoad, {
        filed: "常用明细项",
        name: row.name,
      });
    };

    return { state, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
